import React from "react";
import styles from "./Pagination.module.scss";
import { Button } from "../Button";

interface PaginationProps {
  totalCount: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  loading?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
  totalCount,
  totalPages,
  currentPage,
  pageSize,
  onPageChange,
  loading = false,
}) => {
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalCount);

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const isPreviousDisabled = currentPage <= 1 || loading;
  const isNextDisabled = currentPage >= totalPages || loading;

  return (
    <div className={styles.paginationContainer}>
      <div className={styles.countInfo}>
        {totalCount > 0 ? (
          <span>
            Showing {startItem}-{endItem} of {totalCount} results
          </span>
        ) : (
          <span>No results found</span>
        )}
      </div>
      
      <div className={styles.paginationControls}>
        <Button
          text="Previous"
          variant="secondary"
          onClick={handlePrevious}
          disabled={isPreviousDisabled}
        />
        <Button
          text="Next"
          variant="secondary"
          onClick={handleNext}
          disabled={isNextDisabled}
        />
      </div>
    </div>
  );
};

export default Pagination; 